import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {EncryptionKeysLogs} from '../models/encryptionKeysLogs';
import {BinKey} from '../models/binKey';

@Injectable()
export class BinKeysService {

  constructor(private httpClient: HttpClient) {
  }

  getEncryptionKeysInfo(): Observable<BinKey[]> {
    return this.httpClient.get<BinKey[]>(environment.baseUrlWs + '/api/client/bin-key');
  }

  downloadAvailableEncryptionKeys() {
    return this.httpClient.get(environment.baseUrlWs + '/api/client/get-qed-enc-key?ui=1');
  }

  getEncryptionKeysLogs() {
    return this.httpClient.get<EncryptionKeysLogs[]>(environment.baseUrlWs + '/api/enc-keys-logs');
  }

  getKeysInformation() {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/admin/bin-key-information');
  }
}
